import type { AppState } from '../state/appState.js';
import {
  editorCommandLabelFor,
  type EditorAction,
  type InternalEditorAction,
  type EditorCommandExecutor,
} from './commandExecutor.js';
import type { EditorCommand } from './commandBuilders.js';

const INTERNAL_EDITOR_ACTION_TYPES: Record<InternalEditorAction['type'], true> = {
  'graph:dropNode': true,
  'graph:restoreNode': true,
  'graph:addEdge': true,
  'graph:removeEdge': true,
  'params:deleteValue': true,
  'scene:removeFrame': true,
  'scene:dropInstance': true,
  'scene:dropOwnedInstance': true,
  'scene:dropLayer': true,
  'scene:restoreSubtree': true,
  'component:restore': true,
  'layer:restore': true,
  'editor:restoreSession': true,
  'library:restore': true,
  'component:setSlot': true,
};

function isInternalEditorAction(action: EditorAction): action is InternalEditorAction {
  return action.type in INTERNAL_EDITOR_ACTION_TYPES;
}

export interface EditorRuntime {
  appState: AppState;
  labelCommand: (command: EditorCommand) => string;
  executeCommand: (command: EditorCommand) => ReturnType<EditorCommandExecutor['executeCommand']>;
  executeHistoryAction: (action: EditorAction) => ReturnType<EditorCommandExecutor['executeCommand']>;
}

export function createEditorRuntime(
  appState: AppState,
  executors: EditorCommandExecutor,
): EditorRuntime {
  return {
    appState,
    labelCommand: command => editorCommandLabelFor(appState, command),
    executeCommand: command => executors.executeCommand(appState, command),
    executeHistoryAction: action => isInternalEditorAction(action)
      ? executors.executeInternalAction(appState, action)
      : executors.executeCommand(appState, action),
  };
}
